module.exports = __webpack_public_path__ + "img/511.connection_problem.1754315a.svg";